<template>
  <div class="coupon">
    <div class="none" v-if="!list||list.length==0">
      <img src="/images/unCoupon-bg.png" alt="">
      <p>暂无优惠券</p>
    </div>
    <ul v-else>
      <li v-for="(item, index) in list" :key="item.id" :style="{backgroundImage:`url('${index==beUsed?bgActivePic[index%3]:bgPic[index%3]}')`}">
        <div class="price">
          <span class="top-line" :style="{backgroundColor:priceColor[index%3]}"></span>
            <h2 :style="{color:priceColor[index%3]}">{{item.worth}}</h2>
            <p :style="{color:coinColor[index%3]}">智豆</p>
          <h3>{{item.condition==0?"不限制":`满${item.condition}元可用`}}</h3>
        </div>
        <div class="detail-box">
          <div class="detail">
          <h4>{{item.name}}</h4>
          <h5>{{item.usable|usableTest}}</h5>
          <h6>
              {{item.expireType ? `有效期 ${item.expireEndDate.replace(/\T.*/g, ' ')}`:`还有${item.expireDays}天过期`}}
          </h6>
        </div>
        <button @click="handleButton(index)"  :style="{borderColor:index==beUsed?priceColor[index%3]:'#BABABA', marginBottom: '4px'}">
            <span class="solid" :style="{backgroundColor:index==beUsed?priceColor[index%3]:'transparent'}"></span>
        </button>
        </div>
      </li>
      <li class="nonuse">
        <p>不使用优惠券</p>
        <button @click="beUsed=-1">
            <span class="solid" :style="{backgroundColor:beUsed==-1?'#BABABA':'transparent'}"></span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

  export default {
    components: {

    },
    data() {
      return {
        priceColor: ["#FD616F", "#61CAFF", "#A37DFF"],
        coinColor: ["#FF8867", "#5DC9FF", "#A37DFF"],
        bgActivePic: [
          "/images/coupon_bg_print.png",
          "/images/coupon_bg_blue.png",
          "/images/coupon_bg_purple.png"
        ],
        bgPic:[
          "/images/coupon_bg_print0.png",
          "/images/coupon_bg_blue0.png",
          "/images/coupon_bg_purple0.png"
        ],
        beUsed: -0,
        list: []
      }
    },
    mounted() {
      this.getUserTicket();
    },
    methods:{
      getUserTicket() {
        this.$api.payment_v1_ticket_list_detail_get({
          params:{
             uid: this.uid,
            goodNum: this.$route.query.goodsNum,
            pageNo: 1,
            pageSize: 10
          }
        }).then(e => {
          if(!e) return;
          this.list = e;
        }
        )
      },
      handleButton(index){
         this.beUsed = index;
        // this.$router.push({
        //     path: this.$route.query.redirect
        //   })
      }
    },
    filters:{
      usableTest(params){
        if(params=0){
          return "全场课程均可用"
        }else if(params=1){
          return "指定课程可用"
        }else{
          return "指定分类可用"
        }
      }
    },
    computed: {
    ...mapGetters({
      uid: "auth/uid",
      headers: "auth/headers",
    })
  },
  }
</script>

<style scoped>
  .coupon {
    height: 100vh;
    overflow: auto;
  }

  ul {
    padding-top: 31px;
  }

  li {
    width: 344px;
    height: 130px;
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    border-radius: 5px;
    padding: 20px 14px 22px 13px;
    box-sizing: border-box;
    transition: all 0.3s;
  }

  .price .top-line {
    display: block;
    width: 12px;
    height: 3px;
    border-radius: 1.5px;
    margin: 14px 1px 8px 0;
  }

  .price h2 {
    height: 33px;
    display: inline-block;
    font-size: 30px;
    font-weight: bold;
    line-height: 34px;
  }

  .price p {
    height: 17px;
    display: inline-block;
    font-size: 12px;
    font-weight: normal;
    line-height: 17px;
    margin-left: 3px;
  }

  .price h3 {
    height: 17px;
    font-size: 12px;
    font-weight: normal;
    color: rgba(156, 156, 156, 1);
    line-height: 17px;
    margin-top: 11px;
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }

  .detail-box{
    display: flex;
    width: 200px;
    justify-content: space-between;
  }

  .detail {
    width: 180px;
    position: relative;
  }

  .detail h4 {
    height: 21px;
    font-size: 15px;
    font-weight: normal;
    color: rgba(86, 86, 86, 1);
    line-height: 21px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }

  .detail h5 {
    height: 34px;
    width: 100%;
    font-size: 12px;
    font-weight: normal;
    color: rgba(150, 150, 150, 1);
    line-height: 17px;
    margin: 6px 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .detail h6 {
    height: 16px;
    font-size: 11px;
    font-weight: normal;
    color: rgba(202, 202, 202, 1);
    line-height: 16px;
  }

  li .detail-box button, li.nonuse button{
    display: block;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    border-width: 1px;
    border-style: solid;
    border-color: #BABABA;
    background-color: transparent;
    box-sizing: border-box;
    padding: 0;
    transition: all 0.3s;
    line-height: 15px;
    text-align: center;
  }

  li .detail-box button{
    align-self: flex-end;
  }

  li.nonuse button{
    align-self: center;
  }

  button .solid{
    display: block;
    height: 11px;
    width: 11px;
    border-radius: 50%;
    transition: all 0.3s;
    margin: auto;
    /* vertical-align: middle; */
  }

  li.nonuse{
    height: 50px;
    border: 1px solid #DADADA;
    padding: 15px 11px 14px 20px;
    /* align-items: center; */
  }
  li.nonuse p{
    width:90px;
    height:21px;
    font-size:15px;
    font-weight:400;
    color:rgba(86,86,86,1);
    line-height:21px;
  }

  li+li {
    margin-top: 10px;
  }

  .none {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .none img {
    display: block;
    width: 103px;
    height: 103px;
    margin: 0 auto 24px;
  }

  .none p {
    height: 22px;
    font-size: 16px;
    font-weight: 500;
    color: rgba(157, 157, 157, 1);
    line-height: 22px;
    text-align: center;
  }
</style>